import {AxiosInstance, AxiosResponse} from 'axios';
import {FavoriteFilter, FavoriteFilterScope} from './types';

export interface IFavoriteFiltersApi {
    getMany<T>(scope: FavoriteFilterScope): Promise<AxiosResponse<T>>;
    create(data: {scope: FavoriteFilterScope, name: string, filterPayload: string}): Promise<AxiosResponse<FavoriteFilter>>;
    delete<T extends {id: number}>(id: number): Promise<AxiosResponse<T>>;
}

export default class FavoriteFiltersApi implements IFavoriteFiltersApi {
    private readonly _axiosInstance: AxiosInstance;
    private readonly _controller: string = 'favorite-filters';

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async getMany<T>(scope: FavoriteFilterScope): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.get<T>(`${this._controller}?scope=${scope}`);
    }

    async create(data: {scope: FavoriteFilterScope, name: string, filterPayload: string}): Promise<AxiosResponse<FavoriteFilter>> {
        return await this._axiosInstance.post<FavoriteFilter>(`${this._controller}`, data);
    }

    async delete<T extends {id: number}>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.delete(`${this._controller}/${id}`);
    }
}
